var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnverified = function SvgUnverified(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c1c1c1",
    d: "M14 1a.7.7 0 0 0-1-.7 12.07 12.07 0 0 1-6 1.55A12.2 12.2 0 0 1 1 .3.69.69 0 0 0 0 1v5.84c0 4.64 2.92 7.69 7 9.16 4.08-1.47 7-4.52 7-9.16Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.709 5.858.867.108a.6.6 0 0 0 .635-.383 1.85 1.85 0 0 1 .522-.773q.474-.4 1.179-.4.73 0 1.163.383.431.383.43.921 0 .387-.242.708-.158.204-.967.859-.81.656-1.08 1.181c-.183.358-.247.755-.263 1.153a.6.6 0 0 0 .6.625h.49c.312 0 .57-.239.598-.549q.03-.335.113-.507.142-.295.727-.781 1.132-.937 1.478-1.483.346-.545.346-1.155 0-1.103-.94-1.934T6.835 3q-1.511 0-2.441.82-.793.7-.962 1.655a.323.323 0 0 0 .277.383M7.023 10.882h-.47a.6.6 0 0 0-.6.6v.649a.6.6 0 0 0 .6.6h.47a.6.6 0 0 0 .6-.6v-.649a.6.6 0 0 0-.6-.6"
  }))));
};
export default SvgUnverified;